import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="image" width="100%" theme="lightest" alignment="yes" className="pricing-title-right  div-p-0 left-content mediaSize sale-support-img" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/08ccbb11b68743063a79a6fe3328df91/2_Icon_Support.svg",
        "alt": "adobe-support",
        "title": " "
      }}></img></p>
    <TextBlock slots="heading,text1, text2, buttons" width="100%" theme="lightest" alignment="yes" className="pricing-title-right py-0 text-align-left div-p-0 left-content contact-sales link linking sale-support-btn-align" mdxType="TextBlock" />
    <h3 {...{
      "id": "support"
    }}>{`Support`}</h3>
    <p><strong parentName="p">{`Technical Support and Implementation`}</strong>{` `}</p>
    <p><a parentName="p" {...{
        "href": "/document-services/faq/tech-support/"
      }}>{`Visit our Tech Support FAQ`}</a></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./support.md"
        }}>{`Contact Us`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      